import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { NavLink as Links } from "react-router-dom";
import { Scrollbars } from "react-custom-scrollbars-2";
import jwt from "jsonwebtoken";
import logo from "../../assets/img/logo.svg";
import MenuItems from "./MenuItems";
import { NavDropdown } from "react-bootstrap";

function Sidebar(props) {
  const token = localStorage.getItem("Token");
  const TokenDecode = jwt.decode(token);
  const themes = TokenDecode["themes"];
  const menuItems = props.MenuDetails;
  const viewSideBar = props.sidebarView;
  const ToggleSidebar = props.sidebarToggle;
  const [isMobile, setMobile] = useState(false);
  const company = useSelector((state) => state.Auth.company);
  useEffect(() => {
    if (window.innerWidth <= 990) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, [window.innerWidth]);
  return (
    <React.Fragment>
      {isMobile && viewSideBar ? (
        <div
          className="app-backdrop backdrop-sidebar"
          onClick={ToggleSidebar}
        ></div>
      ) : (
        ""
      )}
      <aside
        className={`sidebar sidebar-expand-lg ${
          viewSideBar ? "sidebar-open" : ""
        }`}
      >
        <header className="sidebar-header bg-theme">
          <Links to="/Dashboard" className="logo-icon">
            <img src={logo} alt={company.Name} width={50} />
          </Links>
          <span className="logo">
            <NavDropdown
              className="topbar-center"
              title={
                <h4 className="pl-10 text-white topbar-title">Dashboard</h4>
              }
            >
              {themes ? (
                <>
                  {themes.map((theme, index) => (
                    <Links
                      className="text-black"
                      to={`/${theme.replace(/[.*+?^${}()&;|[\]\\|\s]/g, "")}`}
                      key={index}
                    >
                      <div className="p-1">
                        <span className="dropdown-item d-flex align-items-center overflow-hidden">
                          <h5 className="title">{theme}</h5>
                        </span>
                        <div className="dropdown-divider" />
                      </div>
                    </Links>
                  ))}
                </>
              ) : (
                ""
              )}
            </NavDropdown>
          </span>
          <span className="sidebar-toggle-fold" onClick={ToggleSidebar} />
        </header>
        <nav className="sidebar-navigation ps-container ps-theme-default ps-active-x ps-active-y">
          <Scrollbars style={{ height: "100vh" }}>
            <ul className="menu pb-30">
              <li className="menu-category">Access Menu</li>
              {menuItems.map((menu, index) => (
                <MenuItems key={index} Items={menu} />
              ))}
            </ul>
          </Scrollbars>
        </nav>
      </aside>
    </React.Fragment>
  );
}
export default React.memo(Sidebar);
